module.exports = __webpack_public_path__ + "img/33-min.88bcede9.jpg";